module.exports = __webpack_public_path__ + "5f97feb1a9b94281deaf04be632e631b.jpg";